'use client'

// import { ActionResult } from '@/actions/types'
import Analytics from '@/components/third-party/analytics'
import { Toaster as SonnerToaster } from '@/components/ui/sonner'
import { Toaster } from '@/components/ui/toaster'
import { NotificationStoreProvider } from '@/providers/notification-store-provider'
import { AppRoutes } from '@/routes'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useSession } from 'next-auth/react'
import { useRouter } from 'next/navigation'
import React, { PropsWithChildren, useEffect, useState } from 'react'

export const Providers = ({
  children,
  devToolState = true,
}: PropsWithChildren<{ devToolState?: boolean }>) => {
  const { data: session } = useSession()
  const router = useRouter()
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // With SSR, we usually want to set some default staleTime
            // above 0 to avoid refetching immediately on the client
            staleTime: 10 * 1000, // 10 seconds
            retry: false,
            // throwOnError: true,
          },
        },
      }),
  )

  useEffect(() => {
    if (session?.error === 'RefreshAccessTokenError') {
      router.push(AppRoutes.signIn())
    }
  }, [session, router])

  // IMQA.init({
  //   collectorUrl: 'https://mon-col.ext.x-arg.com',
  //   serviceName: 'test-service',
  //   serviceVersion: '1.0.0',
  //   serviceKey: 'hello-world',
  //   consoleCapture: true,
  // })
  return (
    <QueryClientProvider client={queryClient}>
      {process.env.NEXT_PUBLIC_ENV === 'prod' && <Analytics />}
      {devToolState && <ReactQueryDevtools initialIsOpen={false} />}
      <Toaster />
      <SonnerToaster position="top-center" duration={2000} richColors />
      <NotificationStoreProvider>{children}</NotificationStoreProvider>
    </QueryClientProvider>
  )
}

// function isActionResult(data: any): data is ActionResult<any> {
//   return data?.statusCode !== undefined
// }
